import React from 'react'

export default function ChatRouletteModule({value, onDataChanged, props}) {
    return <div>
        <hr/>
        <h5 className="hotspot-setting-header">Chat Roulette</h5>
    </div>
}
